import { Context } from "../../Reducers/Store";
import React, { useContext } from "react";

function Loading() {
    const colors = {
        light: {
            backgroundColor: 'rgba(11, 63, 155, 0.9)',
            color: '#ffffff',
            strokeColor: '#ffffff'
        },
        dark: {
            backgroundColor: 'rgba(9, 32, 70, 0.9)',
            color: '#ffffff',
            strokeColor: '#65F839'
        },
        orange: {
            backgroundColor: 'rgba(73, 73, 73, 0.71)',
            color: '#ffffff',
            strokeColor: '#ffffff'
        },
        darkorange: {
            backgroundColor: 'rgba(42, 42, 42, 0.74)',
            color: '#ffffff',
            strokeColor: '#ffffff'
        }
    };

    const [state] = useContext(Context);

    return (<>
        {state.loading &&
            <div style={{
                width: '100%',
                height: '100%',
                position: 'fixed',
                top: 0,
                left: 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 9999,
                backgroundColor: colors.light.backgroundColor,
                color: colors.light.color,
                fontSize: 14,
            }}>
                <svg width="38" height="38" viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg" stroke={colors.light.strokeColor}>
                    <g fill="none" fillRule="evenodd">
                        <g transform="translate(1 1)" strokeWidth="2">
                            <circle strokeOpacity=".5" cx="18" cy="18" r="18" />
                            <path d="M36 18c0-9.94-8.06-18-18-18">
                                <animateTransform
                                    attributeName="transform"
                                    type="rotate"
                                    from="0 18 18"
                                    to="360 18 18"
                                    dur="1s"
                                    repeatCount="indefinite" />
                            </path>
                        </g>
                    </g>
                </svg>
            </div>
        }
    </>);
}
export default Loading;